export interface IGovernmentId {
  readonly status: GovernmentIdStatusEnum;
  readonly identification: string;
  readonly issued: string;
  readonly state: string;
  readonly photo: string;
  readonly expiration: string;
}

export enum GovernmentIdStatusEnum {
  Verified = 'verified',
  Unverified = 'unverified',
  Invalid = 'invalid',
}
